"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const DropdownStyled = styled_components_1.default.div `
    /* Style The Dropdown Button */
    .dropbtn {
        background-color: ${({ theme, buttonTheme, customStyle }) => { var _a, _b; return ((_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.button) === null || _a === void 0 ? void 0 : _a.primary) ? (_b = customStyle === null || customStyle === void 0 ? void 0 : customStyle.button) === null || _b === void 0 ? void 0 : _b.primary : buttonTheme === 'light' ? theme.white : theme.ceruleanBlue; }};
        color: white;
        padding: 5px;
        fonnt-family: ${({ theme, customStyle }) => { var _a; return ((_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.font) === null || _a === void 0 ? void 0 : _a.fontFamily) || theme.defaultFontFamily; }};
        font-size: 16px;
        border: none;
        cursor: pointer;
        border-radius: 5px;
    }

    /* The container <div> - needed to position the dropdown content */
    .dropdown {
        position: relative;
        display: inline-block;
    }

    /* Dropdown Content (Hidden by Default) */
    .dropdown-content {
        display: none;
        position: absolute;
        background-color: #f9f9f9;
        min-width: 160px;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        z-index: 1;
        right: 0;
    }

    /* Links inside the dropdown */
    .dropdown-content a {
        color: black;
        padding: 12px 16px;
        text-decoration: none;
        display: block;
    }

    /* Change color of dropdown links on hover */
    .dropdown-content a:hover {background-color: #f1f1f1}

    /* Show the dropdown menu on hover */
    .dropdown:hover .dropdown-content {
        display: block;
    }

    /* Change the background color of the dropdown button when the dropdown content is shown */
    .dropdown:hover .dropbtn {
        ${({ theme, buttonTheme, customStyle }) => {
    var _a, _b, _c, _d;
    return (`
            background-color: ${((_a = customStyle === null || customStyle === void 0 ? void 0 : customStyle.button) === null || _a === void 0 ? void 0 : _a.secondary) ? (_b = customStyle === null || customStyle === void 0 ? void 0 : customStyle.button) === null || _b === void 0 ? void 0 : _b.secondary : buttonTheme === 'light' ? theme.white : theme.ceruleanBlue};
            color: ${(((_c = customStyle === null || customStyle === void 0 ? void 0 : customStyle.button) === null || _c === void 0 ? void 0 : _c.secondary) ? (_d = customStyle === null || customStyle === void 0 ? void 0 : customStyle.button) === null || _d === void 0 ? void 0 : _d.primary : buttonTheme === 'light' ? theme.ceruleanBlue : theme.white)};
        `);
}}
    }
`;
const Dropdown = ({ title, buttonTheme, options, onSelect, customStyle }) => {
    const displayOptions = options === null || options === void 0 ? void 0 : options.map((option, index) => react_1.default.createElement("a", { href: "javascript:void(0);", onClick: () => onSelect && onSelect(option) }, option.label));
    return (react_1.default.createElement(DropdownStyled, { customStyle: customStyle, buttonTheme: buttonTheme },
        react_1.default.createElement("div", { className: "dropdown" },
            react_1.default.createElement("button", { className: "dropbtn" }, title || ''),
            react_1.default.createElement("div", { className: "dropdown-content" }, displayOptions))));
};
exports.Dropdown = Dropdown;
